import { InternalLinks } from '../../../../../constants';
import glasses from '../../../../../assets/images/kids/glasses.svg';
import question from '../../../../../assets/images/kids/question.svg';

export const links = [
  {
    url: InternalLinks.ecpLocator,
    text: 'kidsProfile.requestAppointment',
    img: glasses,
  },
  {
    url: InternalLinks.aboutProfile,
    text: 'profileAbout.title',
    img: question,
  },
];
